export interface PublishedWebsiteEvent {
  liveUrl?: unknown
  /** Backward-compatible Ros Next event field. */
  url?: unknown
  versionUrl?: unknown
  siteId?: unknown
}

/** Accept only explicit backend fields; never manufacture a stable link by stripping `/vN`. */
export function parsePublishedWebsiteEvent(data: PublishedWebsiteEvent): {
  liveUrl: string
  versionUrl?: string
  siteId: string | number
} | null {
  const liveUrl = typeof data.liveUrl === 'string' ? data.liveUrl : data.url
  if (typeof liveUrl !== 'string' || !isHttpUrl(liveUrl)) return null
  if ((typeof data.siteId !== 'string' || !data.siteId.trim())
    && (typeof data.siteId !== 'number' || !Number.isFinite(data.siteId))) return null
  return {
    liveUrl,
    ...(typeof data.versionUrl === 'string' && isHttpUrl(data.versionUrl) ? {versionUrl: data.versionUrl} : {}),
    siteId: data.siteId,
  }
}

function isHttpUrl(value: string): boolean {
  try {
    const parsed = new URL(value)
    return parsed.protocol === 'https:' || parsed.protocol === 'http:'
  } catch { return false }
}
